import { axios } from '@yarmill/utils';
import { AxiosPromise } from 'axios';
import { AvailableSportsResponse } from '../types';

export function getAvailableSports(): AxiosPromise<AvailableSportsResponse> {
  return axios.get(
    `${process.env.REACT_APP_API_ENV_URL}/api/application/hrZonesApp/def`
  );
}
